import React, { FC } from "react";
import styles from "./RandomFlippedTarotCard.module.scss";
import classNames from "classnames";
import BackTarotCard from "assets/svg/back-tarot-card.svg";

type RandomFlippedTarotCardProps = {
  isCardFlipped: boolean;
  cardUrl?: string;
  customSceneStyles?: any;
  customCardFaceStyles?: any;
  onClick?: ((id: number) => void | undefined) | undefined;
  cardId?: number;
};
const RandomFlippedTarotCard: FC<RandomFlippedTarotCardProps> = ({
  isCardFlipped,
  cardUrl,
  customSceneStyles,
  customCardFaceStyles,
  onClick,
  cardId,
}) => {
  return (
    <div
      className={classNames("pointer", styles.scene, styles.sceneCard)}
      style={customSceneStyles}
      onClick={() => onClick && cardId && onClick(cardId)}
    >
      <div
        className={classNames(styles.card, {
          [styles.isFlipped]: isCardFlipped,
        })}
      >
        <div className={styles.cardFace} style={customCardFaceStyles}>
          <img src={BackTarotCard} alt={""} />
        </div>
        <div className={classNames(styles.cardFace, styles.cardFaceBack)}>
          <img src={cardUrl} alt={""} />
        </div>
      </div>
    </div>
  );
};

export default RandomFlippedTarotCard;
